export default "__VITE_ASSET__d6495750__"